import comp from "./LoginPage";
export default comp;
